import { useEffect, useState } from "react";
import "./Parent.css";
import { useHistory } from "react-router-dom";
import moment from "moment";

import Swal from "sweetalert2";

import axios from "axios";

import loadingImage from "../../assets/images/loading.gif";
import "moment/locale/he";
moment.locale("he");

const Parent = () => {
  const history = useHistory();

  const [nextLessons, setNextLessons] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getNextLessons();
  }, []);

  const getNextLessons = async () => {
    setNextLessons(null);
    try {
      setLoading(true);
      const response = await axios.get("/api/parents/nextLessons", {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      });
      setNextLessons(response.data);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        logout();
      }
    } finally {
      setLoading(false);
    }
  };

  const cancelLesson = async (recordId, dayOfRide, houOfRide) => {
    Swal.fire({
      title: "ביטול שיעור?",
      text: `השיעור מתאריך ${dayOfRide} בשעה ${houOfRide} יבוטל`,
      icon: "error",
      confirmButtonText: "מאשר/ת ביטול",
      showCancelButton: true,
      cancelButtonText: "ביטול",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axios.delete(
            `/api/parents/nextLessons/${recordId}`,

            {
              headers: {
                Authorization: localStorage.getItem("token"),
              },
            }
          );
          if (response.status === 200) {
            Swal.fire({
              icon: "success",
              title: "השיעור בוטל בהצלחה",
              confirmButtonText: "תודה",
            }).then(() => {
              getNextLessons();
            });
          }
        } catch (error) {
          console.log(error);
          Swal.fire({
            icon: "error",
            title: "תקלה בביטול שיעור",
            text: "אנא נסה שנית מאוחר יותר",
            confirmButtonText: "תודה",
          });
        }
      }
    });
  };

  const logout = () => {
    localStorage.clear();
    history.replace("/login");
  };

  return (
    <div id="parentWrapper">
      <div id="main">
        <h1>השיעורים של {localStorage.getItem("firstName")}</h1>
        {loading && (
          <div id="loadingDiv">
            <img src={loadingImage} alt="loading..." />
          </div>
        )}
        {nextLessons &&
          (nextLessons.length === 0 ? (
            <h2>לא נקבעו שיעורים עתידיים</h2>
          ) : (
            <table>
              <thead>
                <tr>
                  <th>תאריך</th>
                  <th>שעה</th>
                  {/* <th>מדריך</th>
                <th>סוס</th> */}
                  {/* <th>ביטול שיעור</th> */}
                </tr>
              </thead>
              <tbody>
                {nextLessons.map((lesson) => {
                  return (
                    <tr key={lesson.RecordId}>
                      <td>{moment(lesson.DayofRide).format("L")}</td>
                      <td>{lesson.HourofRide}</td>
                      <td>
                        {new Date(lesson.DayofRide).toDateString() !==
                          new Date().toDateString() && (
                          <span
                            onClick={() => {
                              cancelLesson(
                                lesson.RecordId,
                                moment(lesson.DayofRide).format("L"),
                                lesson.HourofRide
                              );
                            }}
                            style={{
                              backgroundColor: "red",
                              color: "white",
                              padding: "4px ",
                            }}
                          >
                            ביטול שיעור
                          </span>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          ))}

        <button id="logout" onClick={logout}>
          יציאה מהמערכת
        </button>
      </div>
      <div
        id="newLesson"
        onClick={() => {
          history.push("/parent/addLesson");
        }}
      >
        +
      </div>
    </div>
  );
};

export default Parent;
